<template>
  <div>
    <List
      title="Customers"
      resource="customers"
      :basePath="basePath"
      :request-params="{nonDeleted: true}"
      :fields="fields"
      track-by="customerId"
      ref="list"
      on-row-click="edit"
      routeIdParam="customerId"
      :search="true"
      search-placeholder="Search for a customer by name"
    />
  </div>
</template>

<script>
  import List from '@/components/auth/list/List';
  import ModalNavigation from '@/mixins/ModalNavigation';
  import NotifyMixin from "@/mixins/NotifyMixin";
  import ConfirmationMixin from "@/mixins/ConfirmationMixin";

  export default {
    name: 'CustomersList',
    components: {
      List,
    },
    mixins: [ModalNavigation, NotifyMixin, ConfirmationMixin],
    data: function () {
      return {
        fields: [
          {
            name: 'name',
            title: 'Customer Name',
            sortField: 'name',
            width: '40%',
          },
          {
            name: 'propertiesCount',
            title: 'No. of Communities',
            sortField: 'propertiesCount',
            titleClass: 'text-center',
            dataClass: 'text-center',
            width: '20%',
          },
          {
            name: 'customerUsersCount',
            title: 'No. of Users',
            sortField: 'customerUsersCount',
            titleClass: 'text-center',
            dataClass: 'text-center',
            width: '20%',
          },
          {
            name: 'appsCount',
            title: 'No. of Apps',
            sortField: 'appsCount',
            titleClass: 'text-center',
            dataClass: 'text-center',
            width: '20%',
          },
        ]
      };
    },
    computed: {
      basePath: function () {
        return this.$route.path;
      },
    },
  };
</script>
